import React, { FC } from "react";
import { Box, Grid, GridProps } from "@material-ui/core";

type FormFieldProps = {
  fieldName: string;
};

export const FormField: FC<FormFieldProps & GridProps> = ({
  children,
  fieldName,
  ...gridProps
}) => (
  <Grid item container alignItems="center" {...gridProps} >
    <Grid item xs={4}>
      {fieldName}:
    </Grid>
    <Grid item xs={8} >
      <Box maxWidth={340}>
        {children}
      </Box>
    </Grid>
  </Grid>
);
